export default {"src":"/_next/static/media/fixer.6b274072.svg","height":26,"width":101};